import { ref } from "vue";
import { defu } from "defu";
import { useScrollLock } from "@vueuse/core";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import { matchClass } from "@maas/vue-equipment/utils";
const defaultOptions = {
  focusTrap: false,
  focusTarget: void 0,
  scrollLock: true
};
const scrollLock = typeof window !== "undefined" ? useScrollLock(document?.documentElement) : ref(false);
export function useDrawerDOM(args) {
  const positionFixedElements = ref([]);
  const mappedOptions = defu(args, defaultOptions);
  const focusTrap = mappedOptions.focusTarget ? typeof mappedOptions.focusTrap === "boolean" ? useFocusTrap(mappedOptions.focusTarget) : useFocusTrap(mappedOptions.focusTarget, mappedOptions.focusTrap) : void 0;
  function trapFocus() {
    if (focusTrap) {
      focusTrap.activate();
    }
  }
  function releaseFocus() {
    if (focusTrap) {
      focusTrap.deactivate();
    }
  }
  function lockScroll() {
    if (mappedOptions.scrollLock) {
      scrollLock.value = true;
    }
  }
  function unlockScroll() {
    if (mappedOptions.scrollLock) {
      scrollLock.value = false;
    }
  }
  function addScrollLockPadding() {
    if (typeof window === "undefined") return;
    const exclude = new RegExp(/magic-drawer(__backdrop)?/);
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
    document.body.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
    document.body.style.paddingRight = "var(--scrollbar-width)";
    positionFixedElements.value = [
      ...document.body.getElementsByTagName("*")
    ].filter(
      (x) => getComputedStyle(x, null).getPropertyValue("position") === "fixed" && !matchClass(x, exclude)
    );
    positionFixedElements.value.forEach(
      (elem) => elem.style.paddingRight = "var(--scrollbar-width)"
    );
  }
  function removeScrollLockPadding() {
    document.body.style.paddingRight = "";
    document.body.style.removeProperty("--scrollbar-width");
    positionFixedElements.value.forEach(
      (elem) => elem.style.paddingRight = ""
    );
  }
  return {
    trapFocus,
    releaseFocus,
    lockScroll,
    unlockScroll,
    addScrollLockPadding,
    removeScrollLockPadding
  };
}
